import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import ViewerManager from './viewerManager';
import { useNavigate } from 'react-router-dom';
import createApiClient from '@/api/axiosInstance';

const ThreeDViewer = ({ uniqueKey }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const apiClient = createApiClient(navigate, dispatch);

  const viewerManager = new ViewerManager();
  const [hwv, setHwv] = useState(undefined);
  const [hwvInstantiated, setHwvInstantiated] = useState(false);
  const [designFile, setDesignFile] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // getting the converted file
  useEffect(() => {
    const fetchFileData = async () => {
      setLoading(true);
      setError(null);
      try {
        const gettingPresignedUrlResponse = await apiClient.get(
          `/api/cad/presigned-url`,
          {
            headers: {
              'unique-key': uniqueKey,
            },
          },
        );

        viewerManager.setDesign(gettingPresignedUrlResponse.data.data);

        const hwvInstance = await viewerManager.createViewer('canvas');
        setHwv(hwvInstance);
        setHwvInstantiated(true);
      } catch (error) {
        console.error('Error fetching file data:', error);
        // setError('Failed to load file data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchFileData();
  }, []);

  return (
    <>
      <div id="hoops-container">
        {/* viewer is displayed here */}
        {!loading && (
          <div
            id="canvas"
            className={!loading && 'w-[1200px] h-[600px] bg-gray-200'}
            style={{
              position: 'relative',
            }}
          ></div>
        )}
        {loading && (
          <div className="fixed inset-0 flex items-center justify-center ">
            <div className="flex flex-col items-center text-center text-3xl">
              <div className="mb-4">Loading! Please Wait.</div>
            </div>
          </div>
        )}

        {error && <div>{error}</div>}
      </div>
    </>
  );
};

export default ThreeDViewer;
